import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function Roman() {
  return (
    <AdvisorProvider advisor={advisors["roman"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}